import { ProtocolSettings } from "./ProtocolSettings";
import { ObjUtils } from "../Utils/ObjUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export abstract class CommandLineSettings extends ProtocolSettings {

	public UserName: string;
	public Password: string;
	public EnablePassword: string;
	public Port: number;
	public LoginTimeout: number;	// in milliseconds
	public ReadTimeout: number;		// in milliseconds
	public ReadPause: number;		// in milliseconds
	public ProtocolVersion: string;

	constructor() {
		super();

		this.UserName = "";
		this.Password = "";
		this.EnablePassword = "";
		//this.Port = this.DefaultPort;		// NOW DONE IN SUBCLASS CONSTRUCTORS
		this.LoginTimeout = 2500;
		this.ReadTimeout = 3000;
		this.ReadPause = 0;
		this.ProtocolVersion = "";
	}

	public abstract get DefaultPort(): number;

	public get HasUsername(): boolean {
		return !!this.UserName;
	}

	public get HasPassword(): boolean {
		return !!this.Password;
	}

	public get HasEnablePassword(): boolean {
		return !!this.EnablePassword;
	}

	public get HasPort(): boolean {
		return (this.Port != this.DefaultPort);
	}

	public get HasLoginTimeout(): boolean {
		return (this.LoginTimeout >= 0);
	}

	public get HasReadTimeout(): boolean {
		return (this.ReadTimeout >= 0);
	}

	public get HasReadPause(): boolean {
		return (this.ReadPause >= 0);
	}

	public get HasProtocolVersion(): boolean {
		return !!this.ProtocolVersion;
    }

	public get Summary(): string {
		return `Username: ${this.UserName}; Port: ${this.Port}; Login Timeout: ${this.LoginTimeout}; Read Timeout: ${this.ReadTimeout}`;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof CommandLineSettings))
			return;
		let other = (obj as CommandLineSettings);

		super.Copy(obj);

		this.UserName = other.UserName;
		this.Password = other.Password;
		this.EnablePassword = other.EnablePassword;
		this.Port = other.Port;
		this.LoginTimeout = other.LoginTimeout;
		this.ReadTimeout = other.ReadTimeout;
		this.ReadPause = other.ReadPause;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof CommandLineSettings))
			return false;
		let other: CommandLineSettings = (obj as CommandLineSettings);

		return (ObjUtils.Equals(this.UserName, other.UserName) &&
			ObjUtils.Equals(this.Password, other.Password) &&
			ObjUtils.Equals(this.EnablePassword, other.EnablePassword) &&
			this.Port === other.Port &&
			this.LoginTimeout === other.LoginTimeout &&
			this.ReadTimeout === other.ReadTimeout &&
			this.ReadPause === other.ReadPause &&
			ObjUtils.Equals(this.ProtocolVersion, other.ProtocolVersion));
	}

	public Write(obj: any, context: any): void {

		// Called from subclass Write methods

		super.Write(obj, context);

		if (this.HasUsername)
			obj.user_name = this.UserName;

		if (this.HasPassword)
			obj.password = this.Password;

		if (this.HasEnablePassword)
			obj.enable_password = this.EnablePassword;

		if (this.HasPort)
			obj.port = ValueEncoder.EncodeInteger(this.Port);

		if (this.HasLoginTimeout)
			obj.login_timeout = ValueEncoder.EncodeInteger(this.LoginTimeout);

		if (this.HasReadTimeout)
			obj.read_timeout = ValueEncoder.EncodeInteger(this.ReadTimeout);

		if (this.HasReadPause)
			obj.read_pause = ValueEncoder.EncodeInteger(this.ReadPause);

		if (this.HasProtocolVersion)
			obj.proto_version = this.ProtocolVersion;
	}

	public Read(obj: any, context: any): void {

		// Called from subclass Read methods

		super.Read(obj, context);

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.password !== undefined)
			this.Password = obj.password;

		if (obj.enable_password !== undefined)
			this.EnablePassword = obj.enable_password;

		if (obj.port !== undefined)
			this.Port = ValueEncoder.DecodeInteger(obj.port);

		if (obj.login_timeout !== undefined)
			this.LoginTimeout = ValueEncoder.DecodeInteger(obj.login_timeout);

		if (obj.read_timeout !== undefined)
			this.ReadTimeout = ValueEncoder.DecodeInteger(obj.read_timeout);

		if (obj.read_pause !== undefined)
			this.ReadPause = ValueEncoder.DecodeInteger(obj.read_pause);

		if (obj.proto_version !== undefined)
			this.ProtocolVersion = obj.proto_version;
	}

}

